import isClient from './is-client';

export default function isMobile() {
  if (isClient() && window.matchMedia && window.matchMedia(('(max-width: 1023px)')).matches) {
    return true;
  }
  return false;
}
